export const TinyTalkLogo = ({ className = "w-10 h-10" }: { className?: string }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="TinyTalk logo"
    >
      {/* Background Circle with brand teal */}
      <circle cx="50" cy="50" r="48" fill="#14b8a6" className="transition-colors" />
      
      {/* Speech Bubble */}
      <path
        d="M30 35C30 30.5817 33.5817 27 38 27H62C66.4183 27 70 30.5817 70 35V50C70 54.4183 66.4183 58 62 58H45L35 65V58C31.6863 58 30 56.3137 30 53V35Z"
        fill="white"
        className="drop-shadow-sm"
      />
      
      {/* Animated dots representing speech */}
      <circle cx="42" cy="42" r="3" fill="#14b8a6" className="animate-pulse" style={{ animationDelay: '0ms' }} />
      <circle cx="50" cy="42" r="3" fill="#14b8a6" className="animate-pulse" style={{ animationDelay: '150ms' }} />
      <circle cx="58" cy="42" r="3" fill="#14b8a6" className="animate-pulse" style={{ animationDelay: '300ms' }} />
      
      {/* Baby face silhouette */}
      <circle cx="50" cy="75" r="12" fill="white" opacity="0.95" />
      <path
        d="M50 70C52 70 53 71 53 72C53 73 52 74 50 74C48 74 47 73 47 72C47 71 48 70 50 70Z"
        fill="#14b8a6"
      />
    </svg>
  )
}

export const TinyTalkLogoFull = ({ className = "h-10" }: { className?: string }) => {
  return (
    <div
      className={`flex min-w-0 items-center gap-2 md:gap-3 ${className}`}
      role="img"
      aria-label="TinyTalk Speech Assessment"
    >
      <TinyTalkLogo className="h-8 w-8 shrink-0 md:h-10 md:w-10" />
      <div className="flex min-w-0 flex-col">
        <span className="truncate text-lg font-bold text-primary md:text-2xl">TinyTalk</span>
        <span className="hidden text-xs text-muted-foreground md:block md:-mt-1">
          Speech Assessment
        </span>
      </div>
    </div>
  )
}
